import type { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login').then((component) => component.Login),
  },
  {
    // Enlace del correo de recuperación de clave: público, con el mismo trayecto que usa el backend.
    path: 'asignarNuevaClave/:id',
    loadComponent: () =>
      import('./features/auth/new-password/new-password').then(
        (component) => component.NewPassword,
      ),
  },
  {
    path: '',
    loadChildren: () => import('./routes/private.routes').then((route) => route.PRIVATE_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
